export default __webpack_public_path__ + "static/media/university-of-suffolk.0ac86cf6.svg";